import cookie from 'cookie';

export default function (context) {
  if (process.server) {
    var reqCookies = {};
    var path = context.route.path;
    if (path == '/') {
      //let hostname = context.req.headers['host'];
      var cookies = context.req.headers['cookie'];
      if (context.req.headers.cookie) {
        reqCookies = cookie.parse(cookies);
      }

      //console.log(typeof reqCookies.utm_language, reqCookies);
      var utmLang = typeof reqCookies.utm_language != 'undefined' ? reqCookies.utm_language : null;
      if (!utmLang || utmLang.length != 2) {
        if (typeof global.websiteSettings.extra_info.default_language == 'undefined') {
          utmLang = 'en';
        } else {
          utmLang = global.websiteSettings.extra_info.default_language;
        }
      }

      return context.redirect('/' + utmLang);
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./middleware/root_path.js
// module id = ./middleware/root_path.js
// module chunks = 54